import { useMutation, useQueryClient } from "@tanstack/react-query";
import { publishSync } from "../api/publishSync";
import { toast } from "react-toastify";

export const usePublishSync = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (type) => publishSync({ type }),
    onSuccess: (data, type) => {
      toast.success(`Published ${type} updates successfully.`);
      queryClient.invalidateQueries({ queryKey: ["syncStatus"] });
      queryClient.invalidateQueries({ queryKey: ["pendingChanges", type] });
    },
    onError: (err) => {
      toast.error(err.message || "Failed to publish updates.");
    },
  });
};
